<ngx-loading
  [show]="loader"
  [config]="{ backdropBorderRadius: '0px' }"
></ngx-loading>

<div [ngClass]="toggleProperty ? 'ffcomp2 ffcompVis' : ''" class="comp ffcomp container">
  <div [ngClass]="toggleProperty ? 'flipped' : ''" class="feelFree">
    <form
      *ngIf="parameterValue != 'individual' && success == false"
      [formGroup]="myform"
      (ngSubmit)="onSubmit()"
      class="feelFreeBack"
    >
      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>First Name </mat-label>
          <input formControlName="firstName" required matInput />
        </mat-form-field>

        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>Last Name </mat-label>
          <input formControlName="lastName" required matInput />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>Email </mat-label>
          <input formControlName="email" required matInput />
        </mat-form-field>

        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>Mobile Number </mat-label>
          <input formControlName="phone" required matInput />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput col-12 col-md-6"
        >
          <mat-label>Business Name </mat-label>
          <input formControlName="businessName" matInput />
        </mat-form-field>

        <mat-form-field [hideRequiredMarker]="true" class="col-12 col-md-6">
          <mat-label>Category</mat-label>
          <mat-select
            (selectionChange)="onSelectCatagory($event)"
            formControlName="category"
            required
          >
            <mat-option
              style="
                color: #4d4d4d;
                font-weight: 500;
                font-family: Gill Sans, Gill Sans MT, Calibri, Trebuchet MS,
                  sans-serif;
              "
              *ngFor="let item of catagory"
              [value]="item"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12"
        >
          <mat-label>Message </mat-label>
          <input formControlName="message" required matInput />
          <!-- <textarea formControlName="message" matInput></textarea> -->
        </mat-form-field>
      </div>

      <div class="bottomForm">
        <div class="toggle" (click)="toggle(false)">
          <img src="../../../assets/images/arrow.rightblue.svg" />
        </div>

        <button type="submit" class="ctaButton">Send Message</button>
      </div>
    </form>

    <form
      *ngIf="parameterValue == 'individual' && success == false"
      [formGroup]="indvform"
      (ngSubmit)="onSubmitIndv()"
      class="feelFreeBack feelFreeBackInd"
    >
      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>First Name </mat-label>
          <input formControlName="firstName" required matInput />
        </mat-form-field>

        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>Last Name </mat-label>
          <input formControlName="lastName" required matInput />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>Email </mat-label>
          <input formControlName="email" required matInput />
        </mat-form-field>

        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12 col-md-6"
        >
          <mat-label>Mobile Number </mat-label>
          <input formControlName="phone" required matInput />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-12 col-md-12">
          <mat-label>Merchant Name </mat-label>
          <input formControlName="merchant" matInput />
          <!-- <mat-select (selectionChange)="onSelectMerchant($event)" formControlName="merchant" required>
              <mat-option  *ngFor="let item of catagory" [value]="item">
                {{item.name}}
              </mat-option>
            </mat-select> -->
        </mat-form-field>

        <!-- <mat-form-field class="col-12 col-md-6">
             <mat-label >Branch Name </mat-label>
             <mat-select (selectionChange)="onSelectBranch($event)" formControlName="branch" required>
               <mat-option  *ngFor="let item of catagory" [value]="item">
                 {{item.name}}
               </mat-option>
           
             </mat-select>
           </mat-form-field> -->
      </div>

      <div class="row">
        <mat-form-field
          [hideRequiredMarker]="true"
          class="txtInput usernameInput col-12"
        >
          <mat-label>Message </mat-label>
          <input formControlName="message" required matInput />
          <!-- <textarea formControlName="message" matInput></textarea> -->
        </mat-form-field>
      </div>

      <div class="bottomForm">
        <div class="toggle" (click)="toggle(false)">
          <img src="../../../assets/images/arrow.rightblue.svg" />
        </div>

        <button type="submit" class="ctaButton">Send Message</button>
      </div>
    </form>

    <div class="feelFreeFront">
      <form *ngIf="success" [formGroup]="myform"  class="success">
        <img src="../../../../assets/images/success.gif"/>
        <p class="successT1">Thank you!</p>
        <p class="successT2">Your message has been submitted successfully, we’ll get in touch with you soon.</p>
      </form>
      <div  *ngIf="!success" class="feelFreeFront">
        <img class="wiggle1" src="../../../../assets/images/Subtract.png" />
        <h2 class="leftFeelFree">Feel free to contact us!</h2>
        <div class="rightFeelFree">
          <p class="p2">
            Klickit is happy to hear from you. We’re here to answer any
            questions you might have. Fill in the form below and we’ll connect
            you to the right person.
          </p>

          <a (click)="toggle(false)" class="ctaButton"> {{ ctaButton }} </a>
        </div>
        <img class="wiggle2" src="../../../../assets/images/Subtract1.png" />
      </div>
    </div>
  </div>
</div>
